import React from "react";
import NotificationsPanel from "../../../components/profile/NotificationsPanel";

/**
 * NotificationsPage - User's notifications
 */
const NotificationsPage = () => {
  return <NotificationsPanel />;
};

export default NotificationsPage;
